import React from "react";

const GenericDownloadButton = ({
  downloadImages,
  setIsCheck,
  setIsCheckAll,
  setDownloadImages,
  setArchivedImages,
}) => {
  const handleDownload = () => {
    downloadImages.forEach((item) => {
      const fileurl = item.image.split("$")[0];
      const downloadFileName = item.image.split("$")[1];
      const downloadFileNameExtension = item.image.split("$")[2];
      fetch(fileurl)
        .then((response) => response.blob())
        .then((blob) => {
          const a = document.createElement("a");
          const url = URL.createObjectURL(blob);
          a.href = url;
          a.download = downloadFileName.includes(".")
            ? downloadFileName
            : `${downloadFileName}.${downloadFileNameExtension}`;
          a.click();
          URL.revokeObjectURL(url);
        })
        .catch((error) =>
          console.error("Error downloading attachment:", error)
        );
    });
    // Clear selection states after download
    setIsCheck([]);
    setIsCheckAll(false);
    setDownloadImages([]);
    setArchivedImages([]);
  };

  return (
    <button className="btn-download" onClick={handleDownload} disabled={downloadImages.length === 0}>
      Download
    </button>
  );
};

export default GenericDownloadButton;